<template>
	<section class="hero-section">
		<div class="hero-section__bg hero-section__bg_1 _ibg-contain">
			<img src="@/assets/img/bg/hero/01.png" />
		</div>
		<div class="hero-section__bg hero-section__bg_2 _ibg-contain">
			<img src="@/assets/img/bg/hero/02.png" />
		</div>
		<div class="hero-section__bg hero-section__bg_3 _ibg">
			<img src="@/assets/img/bg/hero/03.png" />
		</div>
		<div class="hero-section__bg hero-section__bg_4 _ibg-contain">
			<img src="@/assets/img/bg/hero/04.png" />
		</div>
		<div class="hero-section__inner _cnt">
			<div class="hero-section__content">
				<div class="hero-section__title _h1">
					{{ $t('Trade CS2 Skins — Fast, Secure, Effortless') }}
				</div>
				<div class="hero-section__line _line">
					<span></span>
				</div>
				<div class="hero-section__text _text-secondary">
					{{
						$t(
							'Whether you’re building your dream inventory or cashing out your rarest finds, SkinSmoke gives you the tools to buy and sell CS2 skins with unmatched speed and safety.'
						)
					}}
				</div>
				<BaseButton
					@click="handleShopNowClick"
					class="hero-section__button _btn-primary"
					><span>{{ $t('Explore Offers') }}</span
					><span
						><svg
							width="23"
							height="23"
							viewBox="0 0 23 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M22.5 11.25C22.5 5.037 17.463 0 11.25 0C5.037 0 0 5.037 0 11.25C0 17.463 5.037 22.5 11.25 22.5C17.463 22.5 22.5 17.463 22.5 11.25ZM11.8856 13.4786C11.8856 13.3129 11.7513 13.1786 11.5856 13.1786H5.175C5.00932 13.1786 4.875 13.0443 4.875 12.8786V9.62137C4.875 9.45569 5.00931 9.32138 5.175 9.32138H11.5856C11.7513 9.32138 11.8856 9.18706 11.8856 9.02138V5.99763C11.8856 5.72713 12.2154 5.59479 12.4024 5.79026L17.4266 11.0426C17.5376 11.1586 17.5376 11.3414 17.4266 11.4574L12.4024 16.7097C12.2154 16.9052 11.8856 16.7729 11.8856 16.5024V13.4786Z"
								fill="white"
							/>
						</svg> </span
				></BaseButton>
			</div>
			<div class="hero-section__scroll">
				<svg
					width="20"
					height="26"
					viewBox="0 0 20 26"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9.75 0.999979V24.3333M9.75 24.3333L18.5 15.5833M9.75 24.3333L1 15.5833"
						stroke="white"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</div>
		</div>
	</section>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { mapActions, mapState } from 'vuex';

export default {
	name: 'HeaderComponent',
	components: { BaseButton },
	props: {
		isAuth: { type: Boolean, required: true },
	},
	data() {
		return {};
	},
	computed: {
		...mapState('app', ['currency']),
	},
	methods: {
		...mapActions('app', ['changeLocale', 'changeCurrency']),
		handleShopNowClick() {
			this.$router.push('/products/all');
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;
//========================================================================================================================================================

.hero-section {
	position: relative;
	min-height: 100vh;
	display: flex;
	align-items: center;
	@include adaptiveValue('padding-top', 100, 55);
	@include adaptiveValue('padding-bottom', 100, 25);
	position: relative;
	overflow: hidden;
	margin-top: -64px;
	@media (max-width: $md1) {
		margin-top: -50px;
	}
	@media (max-width: $md3) {
		min-height: fit-content;
	}
	&__bg {
		position: absolute;
		&_1 {
			width: 50%;
			left: 0px;
			bottom: 0px;
			padding-bottom: 14.5%;
			z-index: -1;
		}
		&_2 {
			width: 52.5%;
			left: -3.5%;
			bottom: -4%;
			padding-bottom: 41.5%;
			z-index: -2;
		}
		&_3 {
			width: 100%;
			height: 100%;
			left: -38%;
			z-index: -3;
			bottom: 0px;
			@media (max-width: $md3) {
				height: 55%;
			}
		}
		&_4 {
			width: 94.5%;
			height: 94%;
			right: 0px;
			top: 10%;
			z-index: -4;
		}
	}
	&__inner {
		flex: 1 1 100%;
	}
	&__content {
		position: relative;
		z-index: var(--base-z-index);
		max-width: 831px;
		margin-left: auto;
		@media (max-width: $md1) {
			background-color: rgba(35, 35, 35, 0.5);
			border-radius: var(--border-radius-primary);
			padding: 20px 10px;
		}
		@media (max-width: $md3) {
			margin: 0px -10px;
		}
	}
	&__title {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 33, 15);
		}
	}
	&__text,
	&__line {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__text {
	}
	&__button {
		display: flex;
		align-items: center;
		gap: 10px;
		span {
			display: flex;
			align-items: center;
			height: 23px;
		}
	}
	&__scroll {
		z-index: var(--secondary-z-index);
		position: absolute;
		left: 50%;
		transform: translate(-50%, 0px);
		animation: scroll-bounce 1.5s ease-in-out infinite;
		@keyframes scroll-bounce {
			0%,
			100% {
				bottom: 15px;
			}
			50% {
				bottom: 25px;
			}
		}
	}
}
</style>
